import api from '#config/api';
import { EXTENDED_TIMEOUT } from '#constants/services';

export const createMash = values => api.post('/mashes', values);

export const getAllMashes = () => api.get('/mashes');

export const getMashById = id => api.get(`/mashes/${id}`);

export const updateMashById = ({ id, values }) => api.patch(`/mashes/${id}`, values);

export const createProductionProcess = values =>
  api.post('/mashes/production-process', values, EXTENDED_TIMEOUT);
